import {CoreDI, Device, DI, FullScreenFader, IAnimation, inject, LAYERS, ReelsScaleService, ScreenParameters, Timer, Tween, UpdateManager, View} from '@gongxigames/framework/slot';
import {Layer} from '@pixi/layers';
import {Sprite} from 'pixi.js';
import {PremonitionConstants} from 'src/premonition/PremonitionConstants';

export class PremonitionView extends View {
    public static readonly NAME: symbol = Symbol('PremonitionView');
    public static readonly PREMONITION_FINISHED: string = '__PREMONITION_FINISHED__';
    @inject(CoreDI.Device)
    protected _device!: Device;
    protected _fader?: FullScreenFader;
    protected _animationContainer: Sprite = new Sprite();
    protected _isPortrait = false;
    protected _spineAnimation?: IAnimation;
    protected _updater: UpdateManager = new UpdateManager(true);

    public init(): void {
        super.init();
        this.initFader();
        this.updateManager.add(this._updater);
        this.container.addChild(this._animationContainer);
    }

    public play(): void {
        this._updater.add(new Timer(() => {
            this.darkenBackground();
        }, PremonitionConstants.PREMONITION_DELAY, true));
    }

    public onResized(screenParams: ScreenParameters): void {
        this._fader?.resize(screenParams);
    }

    protected initFader(): void {
        this._fader = this._displayObjectUtils.createFullScreenFader({alpha: 0});
        this.container.addChild(this._fader);
    }

    protected darkenBackground(): void {
        const faderTween = new Tween(this._fader)
            .to({alpha: PremonitionConstants.BG.alpha}, PremonitionConstants.BG.duration)
            .start()
            .onComplete(() => {
                this.soundPlayer.play('premonition');
                this.playAnimation();
            });

        this._updater.add(faderTween);
    }

    public playAnimation(): void {
        this._spineAnimation = this.spineUtils.createSpineAnimation(this.getSpineName(), this.getAnimationName());
        this._spineAnimation.container.x = this._gameConfig.mainFrame.width / 2;
        this._spineAnimation.container.y = this._gameConfig.mainFrame.height / 2;
        this._spineAnimation.setOnComplete(() => {
            this.onAnimationCompleted();
        });
        this._spineAnimation.start();
        this._animationContainer.addChild(this._spineAnimation.container);
        this.updateManager.add(this._spineAnimation);
    }

    protected onAnimationCompleted(): void {
        const faderTween = new Tween(this._fader)
            .to({alpha: 0}, PremonitionConstants.BG.duration)
            .start()
            .onComplete(() => {
                this.stop();
            });

        this._updater.add(faderTween);
        this.updateManager.remove(this._spineAnimation!);
        this._spineAnimation = undefined;
    }

    protected stop(): void {
        this._animationContainer.removeChildren();
        this._updater.removeAll();
        this.emit(PremonitionView.PREMONITION_FINISHED);
    }

    public onPortrait(): void {
        super.onPortrait();
        this._isPortrait = true;
        this._reelsScaleService.scaleByCurrentScreenOrientation(this._animationContainer);
    }

    public onLandscape(): void {
        super.onLandscape();
        this._isPortrait = false;
        this._reelsScaleService.scaleByCurrentScreenOrientation(this._animationContainer);
    }

    protected getSpineName(): string {
        return 'premonition';
    }

    protected getAnimationName(): string {
        return 'animation';
    }

    public static layer: Layer = LAYERS.POPUPS;
    @inject(DI.ReelsScaleService)
    protected _reelsScaleService!: ReelsScaleService;
}
